var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cont"},[_c('Breadcrumb',{attrs:{"pathList":_vm.pathList}}),_c('div',{staticStyle:{"margin-top":"20px"},domProps:{"innerHTML":_vm._s(_vm.info)}})],1),_c('toTop'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }